import { render, staticRenderFns } from "./ComboboxMask.vue?vue&type=template&id=5261c2a0&scoped=true&"
import script from "./ComboboxMask.vue?vue&type=script&lang=js&"
export * from "./ComboboxMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5261c2a0",
  null
  
)

export default component.exports